export function tapulatorSearch() {
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Tab') {
            event.preventDefault();  // Verhindert das Standardverhalten der Tabulatortaste
            document.getElementById('s').focus();  // Setzt den Fokus auf das Suchfeld
        }
    });
}
